
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-00724366&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InventoryHistory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./InventoryHistory.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-00724366!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InventoryHistory.vue"),
  /* scopeId */
  "data-v-00724366",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Inventory/InventoryHistory.vue
// module id = 614
// module chunks = 0